import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=0c060dd9&scoped=true&"
import script from "./CompanyProfile.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompanyProfile.vue?vue&type=style&index=1&id=0c060dd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c060dd9",
  null
  
)

export default component.exports